import type { z } from 'zod';

/**
 * localStorage wrapper for per-viewer conveniences (theme, locale, panel sizes).
 * Storage can be unavailable (private mode, blocked site data), so every access is guarded
 * and callers always get a valid value or the fallback.
 */
export function readStored<T>(key: string, schema: z.ZodType<T>, fallback: T): T {
  try {
    const raw = globalThis.localStorage.getItem(key);
    if (raw === null) return fallback;
    const parsed = schema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : fallback;
  } catch {
    return fallback;
  }
}

export function writeStored(key: string, value: unknown): void {
  try {
    globalThis.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage full or blocked: preferences simply won't persist.
  }
}
